
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrmAPI } from '../MyAppCommonConfig';

@Injectable({providedIn: 'root'})
export class MarakezService {

    private loadListUrl: string = 'Marakez/LoadList'
    constructor(private http: HttpClient) { }
    
    loadList(phrase: string) {
        return this.http.get(`${CrmAPI}/${this.loadListUrl}?phrase=${phrase}`);
    }
}